import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';
import EditRelease from './EditRelease';
import NewRelease from './NewRelease';

class Container extends Component {
  render() {
    return (
      <div id="releases">
        <Route exact path="/releases" component={List} />
        <Route exact path="/releases/new" component={NewRelease} />
        <Route exact path="/releases/:id/edit" component={EditRelease} />
      </div>
    );
  }
}

export default Container;
